import NewsComp from "./NewsComp";

export default NewsComp